// import ColorThief from 'colorthief';
// export  function getColors(imgUrl, dataList) {
//   return new Promise(resolve => {
//     const originImg = document.createElement('img');
//     originImg.addEventListener('load', async () => {
//       let originImgWidth = originImg.width;
//       let originImgHeight = originImgWidth * 0.618;
//       let halfWidth = originImgWidth * 0.5;
//       let halfHeight = originImgWidth * 0.5 * 0.618;
//       let quarterWidth = originImgWidth * 0.5 * 0.5;
//       let quarterHeight = originImgWidth * 0.5 * 0.5 * 0.618;
//       let posInfos = [{
//         left:0,top:0,width: halfWidth, height: halfHeight
//       }, {
//         left:0,top: halfHeight,width: quarterWidth, height: quarterHeight
//       }, {
//         left: quarterWidth,top: halfHeight,width: quarterWidth, height: quarterHeight
//       },{
//         left: halfWidth,top:0,width: quarterWidth, height: quarterHeight
//       },{
//         left:(halfWidth + quarterWidth),top:0,width: quarterWidth, height: halfHeight
//       }, {
//         left: halfWidth,top: quarterHeight,width: quarterWidth, height: quarterHeight
//       }, {
//         left: halfWidth,top: halfHeight,width: quarterWidth, height: quarterHeight
//       }, {
//         left:(halfWidth + quarterWidth),top: halfHeight,width: quarterWidth, height: quarterHeight
//       }]
//       // 把图片内容使用canvas画到画板上；
//       const originCanvas = document.createElement('canvas');
//       var originCanvasTx = originCanvas.getContext('2d');
//       originCanvas.width = originImgWidth;
//       originCanvas.height = originImgHeight;
//       originCanvasTx.drawImage(originImg, 0, 0,originImgWidth,originImgHeight);
//       await posInfos.forEach(async (item,index) => {
//         let sliceCanvas = document.createElement('canvas');
//         let sliceCanvasTx = sliceCanvas.getContext('2d');
//         let sliceCanvasImageData = originCanvasTx.getImageData(item.left, item.top, item.width, item.height);
//         sliceCanvas.width = item.width;
//         sliceCanvas.height = item.height;
//         sliceCanvasTx.rect(0, 0, item.width , item.height);
//         sliceCanvasTx.fillStyle = 'white';
//         sliceCanvasTx.fill();
//         sliceCanvasTx.putImageData(sliceCanvasImageData, 0, 0);
//         let hslColor = await getImgColor(sliceCanvas);
//         // dataList[index].bgColor = `hsl(${hslColor[0]},${hslColor[1] + 50}%,${hslColor[2] > 70 ? 70 : hslColor[2] }%)`;
//         dataList[index].bgColor = 'rgb(255,255,255)';
//       });
//       resolve(dataList);
//     });
//     originImg.crossOrigin = 'Anonymous';
//     originImg.src = imgUrl;
//   })
// }
// let getImgColor = function(canvas){
//   const colorThief = new ColorThief();
//   return new Promise( resolve => {
//     let img = document.createElement('img');
//     img.addEventListener('load', ()=> {
//       const bgColorArr = colorThief.getColor(img) || [];
//       let hslColor = rgbToHsl(bgColorArr);
//       console.log('hslColor', hslColor);
//       resolve(hslColor);
//     });
//     img.crossOrigin = 'Anonymous';
//     img.src = canvas.toDataURL('image/jpeg');
//   })
// };

  export function rgbToHsl(rgb) {
    let r = rgb[0] / 255;
    let g = rgb[1] / 255;
    let b = rgb[2] / 255;
    let max = Math.max(r, g, b);
    let min = Math.min(r, g, b);
    let delta = max - min;
    let h;
    let s;
    let l;

    if(max === min) {
      h = 0;
    } else if(r === max) {
      h = (g - b) / delta;
    } else if(g === max) {
      h = 2 + (b - r) / delta;
    } else if(b === max) {
      h = 4 + (r - g) / delta;
    }

    h = Math.min(h * 60, 360);

    if(h < 0) {
      h += 360;
    }

    l = (min + max) / 2;

    if(max === min) {
      s = 0;
    } else if(l <= 0.5) {
      s = delta / (max + min);
    } else {
      s = delta / (2 - max - min);
    }

    return([h, s * 100, l * 100]);
  }


